module.exports = __webpack_public_path__ + "static/media/iac.328f58ae.png";